import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCombobox,_vm._b({attrs:{"hide-details":"auto","outlined":"","label":_vm.$t('Tags'),"chips":"","deletable-chips":"","multiple":""},model:{value:(_vm.tags),callback:function ($$v) {_vm.tags=$$v},expression:"tags"}},'v-combobox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }